import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import Header from "../Main/Header";
import { useSelector } from "react-redux";
import { selectSignedIn, selectUserData } from "../../Redux/UserSlice";
import { api_url } from "../../Constants/web_services";

const UserPanelSidebar = () => {
  // const dispatch = useDispatch();
  const isSignedIn = useSelector(selectSignedIn);
  const userData = useSelector(selectUserData);
  const [page, setPage] = useState("dashboard");

  const handlePage = (val) => {
    if (val) {
      setPage(val);
    }
  };
  return (
    <>
      <Header />
      <nav id="sidebar-admin-wraper">
        <div className="pro-my-account-wrap  border-1 d-flex justify-content-center border-top p-3">
          <div className="cover-fill">
            <img src={api_url + "/" + userData.image} alt={userData.username} className="rounded-5" />
            <p className="text-center m-0 mt-2 text-uppercase">{userData.username}</p>
          </div>
        </div>
        <div className="admin-nav">
          <ul className="ps-0">
            {/* <li className="active">
                            <a href="mc-dashboard.html">
                                <i className="fa fa-dashboard" />
                                <span className="admin-nav-text">Dashboard</span>
                            </a>
                        </li> */}
            {isSignedIn ? (
              <>
                <li onClick={() => handlePage("dashboard")}>
                  <Link
                    to={`/user-profile/${userData?.id}`}
                    className={`${page === "dashboard" ? "active-sideNav" : ""
                      } text-decoration-none`}
                  >
                    <i className="fa fa-stack-exchange" />
                    <span className="admin-nav-text">Dashboard</span>
                  </Link>
                </li>
                <li onClick={() => handlePage("profile")}>
                  <Link
                    to={`/user-profile/${userData?.id}/profile`}
                    className={`${page === "profile" ? "active-sideNav" : ""
                      } text-decoration-none`}
                  >
                    <i className="fa fa-user-circle-o" />
                    <span className="admin-nav-text">Profile</span>
                  </Link>
                </li>

                <li onClick={() => handlePage("orders")}>
                  <Link
                    to={`/user-profile/${userData?.id}/orders`}
                    className={`${page === "orders" ? "active-sideNav" : ""
                      } text-decoration-none`}
                  >
                    <i className="fa fa-calendar" />
                    <span className="admin-nav-text">Orders</span>
                  </Link>
                </li>

                <li onClick={() => handlePage("history")}>
                  <Link
                    to={`/user-profile/${userData?.id}/history`}
                    className={`${page === "history" ? "active-sideNav" : ""
                      } text-decoration-none`}
                  >
                    <i className="fa fa-history" />
                    <span className="admin-nav-text">Order History</span>
                  </Link>
                </li>
                <li onClick={() => handlePage("wallet")}>
                  <Link
                    to={`/user-profile/${userData?.id}/wallet`}
                    className={`${page === "wallet" ? "active-sideNav" : ""
                      } text-decoration-none`}
                  >
                    <i className="fa fas fa-money-bills" />
                    <span className="admin-nav-text">Wallet</span>
                  </Link>
                </li>
                {/* <li onClick={() => handlePage("ordersDetail")}>
                  <Link
                    to={`/user-profile/${userData?.id}/order-details`}
                    className={`${
                      page === "ordersDetail" ? "active-sideNav" : ""
                    } text-decoration-none`}
                  >
                    <i className="fa fa-calendar" />
                    <span className="admin-nav-text">Order Detail</span>
                  </Link>
                </li> */}
              </>
            ) : (
              ""
            )}
            {/* <li>
                            <a href="mc-messanger.html">
                                <i className="fa fa-envelope-o" />
                                <span className="admin-nav-text">Messanger</span>
                                <span className="admin-nav-label">4</span>
                            </a>
                        </li>
                        <li>
                            <a href="mc-availability.html">
                                <i className="fa fa-calendar-check-o" />
                                <span className="admin-nav-text">Availability</span>
                            </a>
                        </li>
                        <li>
                            <a href="mc-featured-member.html">
                                <i className="fa fa-user-secret" />
                                <span className="admin-nav-text">Featured Member</span>
                            </a>
                        </li>
                        <li>
                            <a href="mc-team-members.html">
                                <i className="fa fa-users" />
                                <span className="admin-nav-text">Team Members</span>
                            </a>
                        </li>
                        <li>
                            <a href="mc-business-hours.html">
                                <i className="fa  fa-clock-o" />
                                <span className="admin-nav-text">Business Hour</span>
                            </a>
                        </li>
                        <li>
                            <a href="mc-upload-identity.html">
                                <i className="fa fa-id-card-o" />
                                <span className="admin-nav-text">Upload Identity </span>
                            </a>
                        </li>
                        <li>
                            <a href="mc-upgrade-account.html">
                                <i className="fa fa-cloud-upload" />
                                <span className="admin-nav-text">Upgrade Account</span>
                            </a>
                        </li> */}
          </ul>
        </div>
      </nav>

      <Outlet />
    </>
  );
};

export default UserPanelSidebar;
